import { IApplicationState } from '../../types/redux';

export const getBrokerFlow = (state: IApplicationState) => {
  return state.newbuilding.newbuildingBroker?.availableBrokerFlow || null;
};
